import { EventEmitter, Injectable, OnInit, computed, signal } from "@angular/core";
import { HttpService } from "src/app/services/http.service";
import { environment } from "src/environments/environment";
import { Department } from "../features/customer/customer.model";
import { MainStore } from "../common/main.store";
import { CommonService } from "./common.service";

@Injectable({
  providedIn: 'root'
})
export class DepartmentService {

  private _selectedDepartment = signal<Department | null>(null);
  public readonly selectedDepartment = computed(() => this._selectedDepartment());

  constructor(
    private http: HttpService,
    private store: MainStore,
    private commonService: CommonService
  ) {
    this.getdepartmentList();
    const currentDept = this.store.selectedDepartment.get();
    this._selectedDepartment.set(currentDept ?? null);
  }

  async getdepartmentList(): Promise<Department[]> {
    let departmentlist = await this.http.get<Department[]>(`${environment.adminConfig.apiUri}/customer/departments`);
    this.store.departmentList.set(departmentlist);
    return departmentlist;
  }


  public setSelectedDepartment(department: Department): void {
    this.store.selectedDepartment.set(department);
    this._selectedDepartment.set(department);
    this.commonService.DepartmentChanged.emit(department);
  }

  public getDepartment(): Department {
    return this.store.selectedDepartment.get() ?? {} as Department;
  }

  async getDepartments(): Promise<Department[]> {
    let departmentlist = this.store.departmentList.get();
    if (departmentlist != null && departmentlist.length > 0) {
      return departmentlist;
    }
    else {
      return await this.getdepartmentList();
    }
  }

  async getAvailableDepartments(): Promise<Department[]> {
    return await this.http.get<Department[]>(`${environment.adminConfig.apiUri}/user/availabledepartments`);
  }
}


